var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./Banner.jinja');
require('./Banner.less');

module.exports = Base.extend({

    template: template
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/Banner/Banner.js
// module id = 11
// module chunks = 0